import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { NAV } from "../data/content";

const year = new Date().getFullYear();

export const Footer = () => (
  <footer className="relative border-t border-[var(--line)] bg-[var(--paper-2)]/70" data-testid="site-footer">
    <div className="container-x pt-20 lg:pt-24 pb-10">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <LogoMark className="h-16 w-auto" />
          <p className="mt-8 max-w-[22rem] lead">
            Sourcing and distributing branded merchandise for the off-price retail market.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-6">1818 Brands LLC</p>
          <ul className="space-y-3 text-[15px] text-[var(--ink-soft)]" data-testid="footer-contact-placeholders">
            <li>[Office address to be provided]</li>
            <li>[Email to be provided]</li>
            <li>[Phone to be provided]</li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="eyebrow mb-6">Navigate</p>
          <ul className="space-y-3 text-[15px]">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="link-underline pb-0.5" data-testid={`footer-${n.label.toLowerCase()}-link`}>
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="eyebrow mb-6">Inquiries</p>
          <ul className="space-y-3 text-[15px]">
            <li><Link to="/contact?type=suppliers" className="link-underline pb-0.5" data-testid="footer-suppliers-link">Suppliers</Link></li>
            <li><Link to="/contact?type=retail-buyers" className="link-underline pb-0.5" data-testid="footer-buyers-link">Retail Buyers</Link></li>
            <li><Link to="/contact?type=business-partnerships" className="link-underline pb-0.5" data-testid="footer-partners-link">Partnerships</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-20 flex flex-col gap-4 border-t border-[var(--line)] pt-8 text-xs leading-relaxed text-[var(--ink-soft)] md:flex-row md:justify-between">
        <p>© {year} 1818 Brands LLC. All rights reserved.</p>
        <p className="max-w-xl md:text-right">
          All trademarks and logos shown are the property of their respective owners. Their display does not imply endorsement, partnership or exclusive distribution rights.
        </p>
      </div>
    </div>
  </footer>
);
